<script>
import options from './ProfileDeleted.options'
export default options
</script>

<template>
  <article class="kb-changes-saved" aria-live="polite">
    <section class="kb-changes-saved__hero">
      <div class="kb-changes-saved__hero__title-wrapper">
        <h2 class="kb-changes-saved__hero__title-wrapper__title">
          {{ getLabel('title') }}
        </h2>
      </div>
    </section>
    <div class="kb-changes-saved__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>
    <div class="kb-changes-saved__content-container">

      <p v-html="getLabel('text')"></p>
      <button @click="cancelAction" data-order="first" @keydown.tab="tabTrap" class="kb-button">{{
            getLabel('cancelButton')
          }}</button>

    </div>
  </article>
</template>
